import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import * as feather from 'feather-icons';
import { ExxComError } from 'lib/classes/exxcom-error.class';
import { scrollToTop } from 'lib/tools';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { currentYear } from 'lib/tools';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ExxComComponentClass } from 'lib/components/exxcom-component.class';
import { CmsService } from 'lib/services/cms.service';

const scriptName = 'footer.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent extends ExxComComponentClass implements OnInit {
    currentYear: number = currentYear();
    marketoFormId: string = '1497';
    entry: any = {};

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        breakpointObserver: BreakpointObserver,
        public bootstrapMarketoService: BootstrapMarketoService,
        private cmsService: CmsService
    ) {
        super({
            dependencies: {
                platformId: platformId,
                breakpointObserver: breakpointObserver,
            },
        });
    }

    async ngOnInit() {
        try {
            if (!this.isBrowser) {
                return;
            }
            this.entry = await this.cmsService.getFooterCached();
            feather.replace();
        } catch (err) {
            console.error(...new ExxComError(723989, scriptName, err).stamp());
        }
    }

    scrollToTop() {
        try {
            if (!this.isBrowser) {
                return;
            }
            const body = document.body.scrollTop ? document.body : document.documentElement;
            scrollToTop(body, 200);
        } catch (err) {
            console.error(...new ExxComError(834574, scriptName, err).stamp());
        }
    }

    showSslVerification() {
        try {
            if (!this.isBrowser) {
                return;
            }
            const url = 'https://seal.godaddy.com/verifySeal?sealID=f00IwKbVh7Etz1Hs8JGfeV7Y9iDnh3q7MlZL5XGYm5proZYXCWc1tun5BKJY';
            const name = '_blank';
            const specs = ['menubar=no', 'location=no', 'scrollbars=no', 'status=no', 'toolbar=no', 'width=610', 'height=610'].join(', ');
            window.open(url, name, specs);
        } catch (err) {
            console.error(...new ExxComError(384599, scriptName, err).stamp());
        }
    }
}
